import { writable } from "svelte/store";

const statStore = writable('');

const socket = new WebSocket("wss://vy-stats.herokuapp.com/ws");

// Connection Opened
socket.addEventListener("open", function(event) {
    console.log("Connected to server");
});

socket.addEventListener("message", function(event) {
    var data = JSON.parse(event.data);
    console.log("Message from server: ", data);
    statStore.set(data);
});

export default {
    subscribe: statStore.subscribe,
}